<template>
  <!--
  This paragraph is focusable/hoverable for visual scroll animation only.
  It is hidden from screen readers (aria-hidden) and not a true interaction target.
  -->
  <!--eslint-disable-next-line-->
  <p
    ref="textBox"
    class="textBox"
    :dir="rtl ? 'rtl' : 'ltr'"
    @mouseenter="styleOnMouseEnter"
    @focus="styleOnMouseEnter"
    @mouseleave="styleOnMouseLeave"
    @blur="styleOnMouseLeave"
  >
    <span>{{ text }}</span>
  </p>
</template>
<script lang="ts" setup>
import { ref } from 'vue';

const props = defineProps<{
  text: string;
  rtl: boolean;
}>();

const transitionTimePerPixel = 0.01;
const textBox = ref();

const styleOnMouseEnter = () => {
  if (!textBox.value) return;
  const textWidth = textBox.value.lastChild.clientWidth;
  const boxWidth = parseFloat(getComputedStyle(textBox.value).width);
  const translateVal = (props.rtl ? -1 : 1) * Math.min(boxWidth - textWidth, 0);
  textBox.value.lastChild.style.transitionDuration = `${-transitionTimePerPixel * translateVal}s`;
  textBox.value.lastChild.style.transform = `translateX(${translateVal}px)`;
};

const styleOnMouseLeave = () => {
  if (!textBox.value) return;
  textBox.value.lastChild.style.transitionDuration = '0.3s';
  textBox.value.lastChild.style.transform = 'translateX(0)';
};
</script>
<style lang="scss" scoped>
.textBox {
  width: 100%;
  overflow: hidden;
}

.textBox > span {
  display: inline-block;
  white-space: nowrap;
  transition-timing-function: linear;
}
</style>
